import { PRODUCT_TAB_TYPE } from '@moonpig/web-core-brand/config'
import { useStoreId } from '@moonpig/web-core-stores'
import { match } from '@moonpig/web-shared-utils'
import {
  useProductsLocaleText,
  ProductInfoProduct,
  isCardProduct,
  Module,
  E_CARD_SIZE_ID,
  POSTCARD_SIZE_ID,
} from '@moonpig/web-shared-products'
import { createCardMultiBuyConfiguration } from './multibuy/CardMultiBuy'
import { createCardOutOfStockConfiguration } from './out-of-stock/CardOutOfStock'

export const useModuleConfiguration = () => {
  const storeId = useStoreId()
  const localise = useProductsLocaleText()

  return ({ product }: { product: ProductInfoProduct }): Module[] => {
    const conditions = {
      isCard: isCardProduct(product.category.department),
      inStock: product.variants.some(({ inStock }) => inStock),
      type: PRODUCT_TAB_TYPE,
      storeId,
      hasECard: !!product.variants.find(({ key }) => key === E_CARD_SIZE_ID),
      isPostcard: product.masterVariant.key === POSTCARD_SIZE_ID,
    }

    return match(conditions)
      .with(
        { inStock: false }, // prettier-ignore
        () => createCardOutOfStockConfiguration(), // prettier-ignore
      )
      .with(
        { isPostcard: true }, // prettier-ignore
        () =>
          createCardMultiBuyConfiguration({
            localise,
            storeId,
            isPostcard: true,
          }), // prettier-ignore
      )
      .otherwise(
        () =>
          createCardMultiBuyConfiguration({
            localise,
            storeId,
            isPostcard: false,
          }), // prettier-ignore
      )
  }
}
